export const selectGenderList = [
    {title:"Male", key: "1", public_id: 1},
    {title: "Female", key: "2", public_id: 2}
]